import { render } from "./PedidoPaquete.vue?vue&type=template&id=90717e0c&scoped=true"
import script from "./PedidoPaquete.vue?vue&type=script&lang=js"
export * from "./PedidoPaquete.vue?vue&type=script&lang=js"

import "./PedidoPaquete.vue?vue&type=style&index=0&id=90717e0c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90717e0c"]])

export default __exports__